(() => {
    const selector = 'a[data-collection-language-link]';

    function updateLink(link) {
        // Read the current location again after AJAX filtering/sorting or history changes.
        const url = new URL(window.location.href);
        const { languageParam, languageValue, languageRemoveValues } = link.dataset;
        const removedValues = new Set(JSON.parse(languageRemoveValues));
        // Tag filters share a parameter. Preserve unrelated tags and handle Shopify's
        // comma-separated multi-selection as well as repeated query parameters.
        const retainedValues = url.searchParams.getAll(languageParam)
            .flatMap(value => value.split(','))
            .filter(value => value && !removedValues.has(value));
        url.searchParams.delete(languageParam);
        url.searchParams.set(languageParam, [...new Set([...retainedValues, languageValue])].join(','));
        // A changed filter starts on page 1; section_id is only for AJAX rendering.
        url.searchParams.delete('page');
        url.searchParams.delete('section_id');
        link.href = url.pathname + url.search + url.hash;
    }

    function updateLinks() {
        document.querySelectorAll(selector).forEach(updateLink);
    }

    // Delegation also covers replacement sections in the theme editor and AJAX updates.
    for (const eventName of ['pointerdown', 'focusin', 'click', 'auxclick', 'contextmenu']) {
        document.addEventListener(eventName, event => {
            const link = event.target.closest?.(selector);
            if (link) updateLink(link);
        });
    }
    window.addEventListener('popstate', updateLinks);
    document.addEventListener('shopify:section:load', updateLinks);
    updateLinks();
})();
